import { WifiOff } from "lucide-react";

/**
 * "Conexão instável — tentando de novo": faixa NÃO bloqueante por cima do app
 * (o app continua montado e clicável). Aparece com o app já em uso quando a
 * chamada de saúde falha de forma transitória (503, PGRST002, rede) 3 vezes
 * seguidas; some sozinha na primeira resposta boa.
 *
 * Posição: no topo (0,5rem). Com o banner de status visível (AvisoDeStatus, que publica a
 * própria altura em `--pps-aviso-de-status-altura`), desce para logo abaixo dele — quando a
 * API cai, a status page também acusa e as duas aparecem juntas.
 */
const TOPO = "calc(0.5rem + var(--pps-aviso-de-status-altura, -0.5rem) + 0.5rem)";

export function FaixaDeInstabilidade({ texto }: { texto: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      data-pps-component="faixa-de-instabilidade"
      className="pointer-events-none fixed inset-x-0 z-[100] flex justify-center px-4"
      style={{ top: TOPO }}
    >
      <p className="flex max-w-full items-center gap-2 rounded-full border border-amber-300 bg-amber-50 px-4 py-1.5 text-sm font-medium text-amber-900 shadow-sm dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100">
        <WifiOff className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="truncate">{texto}</span>
      </p>
    </div>
  );
}
